/**
 * ProjectTypeService
 * Service for ProjectType entity operations
 * Route: api/project-types
 * Controller: ProjectTypeController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectTypeService
 * Handles project type CRUD operations
 * Maps to /api/project-types endpoint
 */
export class ProjectTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectTypeService.DEFAULT_SERVICE_PATH,
            basePath: ProjectTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectTypeService.DEFAULT_SERVICE_PATH = 'projects';
ProjectTypeService.BASE_PATH = 'api/project-types';
//# sourceMappingURL=ProjectTypeService.js.map